import styled, { keyframes } from 'styled-components'

const orbit = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const pulse = keyframes`
  0%, 100% {
    transform: scale(0.96);
    opacity: 0.9;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
`

const shimmer = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
`

export const LoaderShell = styled.div`
  position: relative;
  width: 104px;
  height: 104px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: radial-gradient(circle at center, rgba(255, 255, 255, 0.96) 0%, rgba(244, 248, 253, 0.9) 72%);
  box-shadow: 0 22px 46px rgba(23, 55, 77, 0.12);
`

export const LoaderRing = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 6px solid rgba(182, 194, 214, 0.38);
  border-top-color: #c6016b;
  border-right-color: #2d749c;
  animation: ${orbit} 1.15s linear infinite;
`

export const LoaderCore = styled.div`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: linear-gradient(135deg, #c6016b 0%, #2d749c 100%);
  background-size: 180% 180%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 14px 28px rgba(45, 116, 156, 0.2);
  animation: ${pulse} 1.8s ease-in-out infinite, ${shimmer} 2.2s linear infinite alternate;
`

export const BrandMark = styled.span`
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.04em;
`
